export { default } from './AppContainer';
